import { AfterViewInit, Component } from '@angular/core';
import { DialogBaseComponent } from './dialog_base.component';
import * as $ from 'jquery';
import { ShopifyService } from '../../shared/services/shopify.service';
import { ToastService } from '../../../shared/services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { PostAutomaticInstallComponent } from './post_automatic_install.component';
import { take } from 'rxjs/operators';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../app_state';

@Component({
  selector: 'yi-integrate-install-automatically-dialog',
  template: require('./install_automatically.component.html'),
  styles: [require('./install_automatically.component.scss')]
})
export class InstallAutomaticallyComponent extends DialogBaseComponent implements AfterViewInit {

  private toastr;
  private translate;
  private nextComponent = PostAutomaticInstallComponent;
  private isWidgetV3: boolean;
  private widgetInstanceId: number;

  constructor(redCrossService: AnalyticsTrackingProvider,
              shopifyService: ShopifyService,
              toastr: ToastService,
              store: Store<IAppState>,
              translate: TranslateService) {
    super('', redCrossService, false);
    this.toastr = toastr;
    this.translate = translate;

    store.select(state => state.app.install).pipe(take(1)).subscribe(
      installState => {
        this.widgetInstanceId = installState.widget.widgetV3InstanceId;
        this.isWidgetV3 = installState.integrate.hasWidgetV3;
      });

    const params = {
      widgetV3Enabled: this.isWidgetV3,
      widgetV3InstanceId: this.widgetInstanceId
    };
    shopifyService.autoInstall(params).pipe(take(1)).subscribe(
      () => {
        this.completeAnimation();
      }
      , (ex) => {
        this.displayError(ex.type);
        this.close();
      });
  }

  ngAfterViewInit() {
    $('.progress-bar').animate({
      width: '70%'
    }, 2500);
  }

  completeAnimation() {
    $('.progress-bar').animate({
      width: '100%'
    }, 1500, () => {
      this.moveToNextDialog();
    });
  }

  moveToNextDialog() {
    this.nextDialog.emit(this.nextComponent);
  }

  displayError(type) {
    if (type.indexOf('ThemeLiquidException') > 0) {
      this.toastr.error('install', 'ThemeLiquidException', this.translate.instant('DIALOGS.INSTALL_AUTOMATICALLY.ERRORS.THEME'));
    } else if (type.indexOf('ProductLiquidException') > 0) {
      this.toastr.error('install', 'ProductLiquidException', this.translate.instant('DIALOGS.INSTALL_AUTOMATICALLY.ERRORS.PRODUCT'));
    } else {
      this.toastr.error('install', 'shopifyService.autoInstall', this.translate.instant('DIALOGS.INSTALL_AUTOMATICALLY.ERRORS.GENERIC'));
    }
  }
}




